// extracted by mini-css-extract-plugin
export var profileTabSeparator = "profile-tab-separator_QQNptenINtWma8WUAP4W";